import React from 'react';
import { Card, Button, Typography, theme } from 'antd';
import { PlusCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../Shared/GlobalContext/ThemeContext';

const { Text } = Typography;

const BalanceCard = ({ user, onAddCoins, cardStyle }) => {
  const { t } = useTranslation();
  const { token } = theme.useToken();

  return (
    <Card
      style={{ ...cardStyle, height: '100%' }}
      title={t('balance')}
      extra={
        <Button
          variant="solid"
          color="success"
          icon={<PlusCircleOutlined />}
          onClick={onAddCoins}
        >
          {t('need_coins')}
        </Button>
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <Text strong style={{ fontSize: '24px', color: token.colorText }}>
          {user.balance?.available_coins || 0} {t('coins')}
        </Text>
      </div>
    </Card>
  );
};

export default BalanceCard; 